import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box
} from "@mui/material";
import { getReassignatioHistory } from "../../../config";

const ReassignmentHistoryDialog = ({ openReassignmentHistoryDialog, onClose, token, id_box }) => {
    const [historyList, setHistoryList] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchReassignmentHistory = async () => {
        getReassignatioHistory(token, id_box)
            .then(resp => resp.json())
            .then(data => {
                console.log("Received data:", data);
                if (Array.isArray(data)) {
                    setHistoryList(data);
                } else {
                    setHistoryList([]);
                }
            })
            .catch(err => {
                console.error("Error getting box-status:", err);
                setHistoryList([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (openReassignmentHistoryDialog && id_box) {
            setLoading(true);
            fetchReassignmentHistory();
        }
    }, [openReassignmentHistoryDialog, id_box]);

    return (
        <Dialog
            open={openReassignmentHistoryDialog}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>Historial de Reasignación</DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center" mt={4}>
                        <CircularProgress />
                    </Box>
                ) : historyList.length === 0 ? (
                    <Typography align="center" mt={4}>
                        No hay datos para mostrar.
                    </Typography>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell># Asignación</TableCell> */}
                                <TableCell>Delivery Name</TableCell>
                                <TableCell>Box ID</TableCell>
                                <TableCell>Fecha Delivery / Pickup</TableCell>
                                <TableCell>Ruta</TableCell>
                                <TableCell>Pago Recibido</TableCell>
                                <TableCell>Motivo</TableCell>
                                <TableCell>Estado</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {historyList.map((row, index) => (
                                <TableRow key={index}>
                                    {/* <TableCell>{row.assignment_number}</TableCell> */}
                                    <TableCell
                                        style={{
                                            fontWeight: 'bold',
                                            color: row.delivery_name ? 'green' : 'red',
                                        }}
                                    >
                                        {row.delivery_name ? row.delivery_name : 'N/A'}
                                    </TableCell>
                                    <TableCell>{row.box_id}</TableCell>
                                    <TableCell>{row.delivery_date}</TableCell>
                                    <TableCell>{row.route_name}</TableCell>
                                    <TableCell>{row.payment_received ? row.payment_received : '0'}</TableCell>
                                    <TableCell>{row.reason}</TableCell>
                                    <TableCell>{(row.box_status === '1' || row.box_status === 1) ? 'Delivery' : 'Pickup'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReassignmentHistoryDialog;
